import React from 'react'
import {withTheme} from 'styled-components'
import {getLocationSetter} from 'utils/browserUtils'
import config from 'config'
import {LOGIN_CASES} from 'const'
import {getLang, getLoginCase} from 'utils/stringUtils'
import SummitsLogos from './SummitsLogos'
import WinterAwardsLogos from './WinterAwardsLogos'
import {HeaderLogo} from './HeaderLogosStyles'

const HeaderLogos = ({theme, isScrolling}) => {
  const lang = getLang(window.location.search) || 'de'
  const loginCase = getLoginCase(window.location.search)
  const homeLink = theme.brand.url

  switch (loginCase) {
    case LOGIN_CASES.BLICK.SUMMITS:
      return <SummitsLogos theme={theme} lang={lang} homeLink={homeLink} />

    case LOGIN_CASES.BLICK.WINTER_AWARDS:
      return <WinterAwardsLogos theme={theme} lang={lang} homeLink={homeLink} isScrolling={isScrolling} />

    default:
      return (
        <HeaderLogo
          src={`${config.url}/assets/${theme.shell.header.icon.image}`}
          onClick={getLocationSetter(homeLink)}
        />
      )
  }
}

export default withTheme(HeaderLogos)
